export enum SubscriptionBillingInterval {
  YEAR = 'year',
  MONTH = 'month',
}

export enum PlanBilledBy {
  ROBOT = 'robot',
}
